import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { Modal } from 'react-bootstrap';
import { Button, ButtonBar, Loader } from '../../../../common/components';
import React from 'react';
import { connect } from 'react-redux';

import { compose } from 'redux';
import FieldFormControl from '../../../../common/components/FieldFormControl/FieldFormControl';

const NoSchemes = ({ unassignedSchemes }) => {
  if (!unassignedSchemes) {
    return <Loader />;
  }
  if (unassignedSchemes.length === 0) {
    return <p>No Available Scheme Found</p>;
  }

  return null;
};

const UnassignedSchemes = ({ unassignedSchemes, onSelectAll }) => {
  const toggleSelectAll = (e) => {
    const schemes = unassignedSchemes?.reduce((carry, scheme) => {
      carry[scheme.id] = { add: e.currentTarget.checked };
      return carry;
    }, {});
    onSelectAll(schemes);
  };

  if (!unassignedSchemes?.length) {
    return null;
  }
  return (
    <>
      <div>
        <Field
          name={'selectAllUnAssignedSchemes'}
          type="checkbox"
          onChange={toggleSelectAll}
          component={FieldFormControl}
        >
          <div className="add-scheme-to-campaign-item">
            <h4>All</h4>
          </div>
        </Field>
      </div>
      {unassignedSchemes.map((scheme, index) => {
        return (
          <div key={index}>
            <Field
              name={`schemes[${scheme.id}].add`}
              type="checkbox"
              value={index}
              component={FieldFormControl}
            >
              <div className="add-scheme-to-campaign-item">
                <h4>
                  {scheme.name} - V{scheme.versionNumber}
                </h4>
              </div>
            </Field>
          </div>
        );
      })}
    </>
  );
};
const AddSchemesToCampaignForm = ({
  unassignedSchemes,
  handleSubmit,
  onSave,
  onCancel,
  submitting,
  dispatch,
  change,
}) => {

  const selectAll = (schemes) => {
    dispatch(change('schemes', schemes));
  };
  return (
    <Form onSubmit={handleSubmit(onSave)}>
      <Modal.Body>
        <div className="add-scheme-to-campaign-item-container">
          <p>
            {' '}
            Any schemes created after a campaign was set up will not automatically be
            attached to a Campaign; please select from the list below the schemes you
            would like to attach to this campaign{' '}
          </p>
          <NoSchemes unassignedSchemes={unassignedSchemes} />

          <UnassignedSchemes
            unassignedSchemes={unassignedSchemes}
            onSelectAll={selectAll}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ButtonBar>
          <Button
            type="submit"
            className="pull-right settings-button"
            bsStyle="danger"
            label="Add Schemes"
            disabled={submitting}
            isLoading={submitting}
          />
          <Button
            className="pull-right"
            bsStyle="default"
            handleClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </Button>
        </ButtonBar>
      </Modal.Footer>
    </Form>
  );
};

const FORM_NAME = 'AddSchemesToCampaignModal';
export default compose(
  connect((state) => ({
    formValues: getFormValues(FORM_NAME)(state),
  })),
  reduxForm({
    form: FORM_NAME,
  }),
)(AddSchemesToCampaignForm);
